import React, { FC } from 'react';
import { MenuItem } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { ISuggestionProps, SuggestionType } from './types';
import GroupItem from './Group';
import ProfileItem from './Profile';
import DepartmentItem from './Department';
import LocationItem from './Location';
import SegmentItem from './Segment';

interface IPropsEnhanced extends WithStyles<typeof styles> {
  type: SuggestionType;
  suggestionProps: ISuggestionProps;
}

const styles = (theme: Theme) =>
  createStyles({
    item: {
      '&$selected, &$selected:hover': {
        backgroundColor: theme.custom.palette.grey4,
        color: theme.custom.palette.black2,
        fontWeight: theme.typography.fontWeightBold,
      },
    },
    selected: {},
  });

const Suggestion: FC<IPropsEnhanced> = props => {
  const { classes, suggestionProps, type } = props;
  const { suggestion, index, itemProps, highlightedIndex } = suggestionProps;
  const isHighlighted = highlightedIndex === index;

  let item = null;

  switch (type) {
    case 'group':
      item = <GroupItem group={suggestion} />;
      break;
    case 'profile':
      item = <ProfileItem profile={suggestion} />;
      break;
    case 'department':
      item = <DepartmentItem department={suggestion} />;
      break;
    case 'location':
      item = <LocationItem location={suggestion} />;
      break;
    case 'segment':
      item = <SegmentItem segment={suggestion} />;
  }

  return (
    <MenuItem
      {...itemProps}
      key={suggestion.id}
      classes={{ root: classes.item, selected: classes.selected }}
      selected={isHighlighted}
      component="div">
      {item}
    </MenuItem>
  );
};

export default withStyles(styles)(Suggestion);
